import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const PricingConfig = {
  type: 'PricingConfig',
  formTitle: 'Pricing Configuration',
  formUrl: '/Sales/PricingConfig/',
  screenReference: 'SALES_PRICING_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default PricingConfig;
